<template>
    <v-app>
        <v-navigation-drawer app v-model="drawer" clipped>
            <v-container>
                <v-list dense nav>
                    <!--topに戻る機能追加-->
                    <v-list-item @click="changePage('top')">
                        <v-list-item-title>トップページ</v-list-item-title>
                    </v-list-item>

                    <v-list-group v-for="menu_list in menu_lists"
                                  :key="menu_list.name"
                                  :prepend-icon="menu_list.icon"
                                  no-action
                                  :append-icon="menu_list.lists ? undefined : ''">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ menu_list.name }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="list in menu_list.lists" :key="list.name" @click="changePage(list.link)">
                            <v-list-item-content>
                                <v-list-item-title><span v-html="list.name"></span></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content>
                        <v-menu bottom>
                            <template v-slot:activator>
                                <v-list-item @click="doLogout">

                                    ログアウト

                                </v-list-item>
                            </template>

                        </v-menu>

                    </v-list-item-content>
                </v-list-item>
            </v-container>
        </v-navigation-drawer>


        <v-app-bar app dark color="#0075c2" clipped-left>

            <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>

            <!--topに戻る機能追加-->
            <v-toolbar-title @click="changePage('top')">
                運送業務システム
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items style="margin-top:15px;margin-left:30px;">
                <!--<p class="text-right">ユーザー情報：{{cmn_store.user_info.login_id}} {{cmn_store.user_info.user_name}}<br />センター情報：{{cmn_store.user_info.jigyosho_code}} テストセンター</p>-->
                <p class="text-right">ユーザー情報：{{cmn_store.user_info.login_id}} {{cmn_store.user_info.user_name}}<br />センター情報：{{cmn_store.user_info.jigyosho_code}} {{cmn_store.user_info.jigyosho_name}}</p>
            </v-toolbar-items>
        </v-app-bar>

        <v-main>
            <slot></slot>
            <!--{{cmn_store.user_info}}-->
        </v-main>

        <v-footer color="#0075c2" dark app>
            浪速運送株式会社 Ver - {{ version }}
            <div @click="changePage('KansenMatrixMaster')">&nbsp;&nbsp;</div>
            <v-spacer></v-spacer>
            <div @click="changePage('FukutsuStoreMaster')">&nbsp;&nbsp;</div>
        </v-footer>
        <MyLoading></MyLoading>
    </v-app>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data: () => ({
            isOpenSideMenu: false,
            drawer: null,
            version: g_version,

            menu_lists: [
                {
                    name: 'マスタ',
                    icon:'',
                    lists: [
                        //{ name: 'ログインユーザ', link:'Top'},
                        //{ name: 'ハンディ―ターミナル', link: 'Top' },
                        //{ name: 'コース', link: 'Top' },
                        { name: '施設マスタ', link: 'ShisetsuMaster' },
                        { name: 'リードタイムマスタ', link: 'LeadTimeMaster' },
                       /* { name: '福通支店マスタ', link: 'FukutsuStoreMaster' }*/
                    ]
                },
               // {
               //     name: '運行入力',
               //     icon: '',
               //     lists: [
               //         { name: '集荷オーダー登録', link: 'Top' },
               //         { name: '集荷オーダー振分', link: 'Top' },
               //     ]
               //},
                {
                    name: '運行照会',
                    icon: '',
                    lists: [
                        { name: '送り状', link: 'ReferenceOkurijyo' },
                    //    { name: '端末運用状', link: 'Top' },
                    //    { name: '子札履歴', link: 'Top' },
                    //    { name: '貨物追跡ホスト連携', link: 'Top' },
                        { name: '配送送り状明細照会', link: 'ReferenceHaitatuNioroshi' },
                        { name: '商品到着照会', link: 'ReferenceShouhinTouchaku' },
                        { name: '福山通運様引渡照会<br>(浪速→福通様)', link: 'ReferenceFukutsuRenkei' },
                        { name: '配送先店舗別積込照会', link: 'ReferenceHaitatsuCheck' },
                        { name: '四国ジョイント', link: 'ReferenceShikokuJoint' },
                        { name: '本線到着便照会', link: 'ReferenceHonsenTotyaku' },
                        /*{ name: '貨物の問い合わせ', link: 'CargoInquiry' },*/
                    ]
                },
           //     {
           //         name: '帳票',
           //         icon: '',
           //         lists: [
           //             { name: '集荷オーダーリスト', link: 'Top' },
           //             { name: '集荷リスト', link: 'Top' },
           //             { name: '積込リスト', link: 'Top' },
           //             { name: '配達リスト', link: 'Top' },
           //             { name: '集荷リスト(画像)', link: 'Top' },
           //             { name: '積込リスト(画像)', link: 'Top' },
           //             { name: '配達リスト(画像)', link: 'Top' },
           //             { name: '商品確認表', link: 'Top' },
           //         ]
           //     },
           //     {
           //         name: '店着管理',
           //     },
           //     {
           //         name: 'NAIS',
           //     },
           ],
            mnMaster: [
                'ログインユーザ',
                'ハンディ―ターミナル',
                'コース'
            ],
            mnOperationInput: [
                '集荷オーダー登録',
                '集荷オーダー振分'
            ],
            mnOperationInquiry: [
                {
                    name: '送り状',
                    action: 'reference_okurijyo'
                },
                {
                    name: '端末運用',
                    action: '/reference_okurijyo/'
                },
                {
                    name: '本線到着車両状況',
                    action: '/reference_okurijyo/'
                },
                {
                    name: '子札履歴',
                    action: '/reference_okurijyo/'
                },
                {
                    name: '貨物追跡ホスト連携',
                    action: '/reference_okurijyo/'
                }
            ],
            mnReport: [
                '集荷オーダーリスト',
                '集荷リスト',
                '積込リスト',
                '配達リスト',
                '集荷リスト(画像)',
                '積込リスト(画像)',
                '配達リスト(画像)',
                '商品確認表' 
            ],
        }),
        computed: {
            ...mapState({
                cmn_store: state => state.common_store,
            }),
        },
        methods: {
            changePage(action) {
                const w = window.location;
                w.href = `/${action}`;
            },

            doLogout() {
                window.location.href = '/LoginPC/Logout';
            },

        },

    };
</script>
